import React, { Component } from "react";
import moment from "moment";
// material ui
import withStyles from "@material-ui/styles/withStyles";
// charts
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
// icons
import ExcelIcon from "mdi-material-ui/FileExcel";
//jazasoft
import { Button, RestMethods, FETCH_START, FETCH_END } from "jazasoft";
//local
import Report from "./Report";

//helpers
import { dataProvider } from "../../../App";
import handleError from "../../../utils/handleError";

const actionList = [
  { name: "summary", title: "Monitor Summary" },
  { name: "consumption", title: "Consumption" }
];

export const getReportSerchText = ({ start, end, customerList, productList }) => {
  let filters = [];
  if (start) {
    start = !isNaN(start) ? moment(start).valueOf() : moment(start, "YYYY-MM-DD").valueOf();
    filters.push(`createdAt=ge=${start}`);
  }
  if (end) {
    end = !isNaN(end) ? moment(end).valueOf() : moment(end, "YYYY-MM-DD").valueOf();
    filters.push(`createdAt=le=${end}`);
  }
  if (customerList && customerList.length > 0) {
    filters.push(`customer=in=(${customerList.map(({ name }) => `'${name}'`).join(",")})`);
  }
  if (productList && productList.length > 0) {
    filters.push(`product=in=(${productList.map(({ name }) => `'${name}'`).join(",")})`);
  }
  return filters.join(";");
};

const styles = {
  root: {
    margin: "1.5em 0"
  },
  content: {
    display: "flex",
    justifyContent: "center"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center"
  }
};

class EndBitsReportView extends Component {
  state = {
    page: 1,
    month: null,
    rollList: []
  };

  onDownload = action => () => {
    const { month } = this.state;
    let filter = { ...this.props.filter };
    if (month) {
      filter = {
        ...filter,
        start: moment(month, "MMM, YY").startOf("month").toDate().getTime(),
        end: moment(month, "MMM, YY").endOf("month").toDate().getTime()
      };
    }
    const search = getReportSerchText(filter || {});

    const options = {
      url: "monitors",
      responseType: "arraybuffer",
      params: { action, search }
    };

    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          const header = response.headers["content-disposition"];
          var filename = header ? header.match(/filename="(.+)"/)[1] : "MONITOR SUMMARY.xlsx";

          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        this.props.dispatch({ type: FETCH_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
      });
  };

  onBack = () => {
    if (this.state.page === 1) {
      this.props.history.goBack();
    } else if (this.state.page === 2) {
      this.setState({ page: this.state.page - 1, month: null });
    } else if (this.state.page === 3) {
      this.setState({ page: this.state.page - 1, rollList: [], poRef: null });
    }
  };

  onClick =
    ({ column, record }) =>
    e => {
      if (column.dataKey === "month") {
        this.setState({ page: this.state.page + 1, [column.dataKey]: record[column.dataKey] });
      } else if (column.dataKey === "poRef") {
        const options = {
          url: `orders/${record.orderId}/rolls`,
          method: "get",
          params: { flowId: record.orderFlowId }
        };
        this.setState({ page: this.state.page + 1, poRef: record.poRef });
        this.props.dispatch({ type: FETCH_START });
        dataProvider(RestMethods.CUSTOM, undefined, options)
          .then(response => {
            this.setState({ rollList: response.data });
            this.props.dispatch({ type: FETCH_END });
          })
          .catch(err => {
            handleError(err, this.props.dispatch);
            this.props.dispatch({ type: FETCH_END });
          });
      }
    };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.content}>
          {actionList.map((action, idx) => (
            <Button
              key={idx}
              color="primary"
              variant="contained"
              style={{ margin: "1.5em" }}
              onClick={this.onDownload(action.name)}>
              <ExcelIcon style={{ marginRight: 4 }} />
              {action.title}
            </Button>
          ))}
        </div>
      </div>
    );
  }
}

const StyledEndBitsReport = withStyles(styles)(EndBitsReportView);

const EndBitsReport = props => (
  <Report
    title="Planning Monitor Report"
    defaultMonths={1}
    filterKeys={["start", "end", "product", "customer"]}
    {...props}>
    <StyledEndBitsReport {...props} />
  </Report>
);

export default EndBitsReport;
